// extracted by css-extract-rspack-plugin
export default {"textStyles":"InvalidLink_textStyles__QJ-Cy"};